
import { Link } from 'react-router-dom';

export default function FAQSection() {
  const faqs = [
    {
      question: 'Q. ブランクが5年以上ありますが、大丈夫でしょうか?',
      answer: 'A. もちろん大丈夫です。当社の登録スタッフの40%がブランクからの復帰です。事前面談や職場見学を通じて、安心して復帰できる職場をご案内いたします。'
    },
    {
      question: 'Q. 週3日だけでも本当に働けますか?',
      answer: 'A. はい、可能です。週3日、1日6時間からの勤務も多数ご用意しています。実際に60代の女性の方でも、週3日の出勤で毎月16万円の収入に繋がっています。'
    },
    {
      question: 'Q. LINE での相談はどのくらいで返信がありますか?',
      answer: 'A. 平日9:00-18:00の間でしたら、通常1時間以内にお返事いたします。土日祝日も営業しておりますので、お気軽にお問合せください。'
    },
    {
      question: 'Q. 登録や相談に費用はかかりますか?',
      answer: 'A. 一切かかりません。登録、相談、職場紹介まですべて無料です。無理な営業や、ご連絡も一切しませんのでご安心してご利用ください。'
    },
    {
      question: 'Q. 派遣で働くのが初めてです。どんな仕組みですか?',
      answer: 'A. 派遣の仕組みは、派遣元(トラスト)が雇用主となり、派遣先(施設)にあなたを派遣します。給与や福利厚生は派遣元が担当し、派遣先では施設の指示を受ける形です。'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <Link to="/faq" className="inline-block cursor-pointer group">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 sm:mb-6 group-hover:text-blue-500 transition-colors flex items-center justify-center gap-2">
              よくあるご質問
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-2xl opacity-0 group-hover:opacity-100 transition-opacity"></i>
              </div>
            </h2>
          </Link>
          <p className="text-lg sm:text-xl text-gray-600">
            皆さまからよくいただくご質問にお答えします
          </p>
        </div>
        <div className="space-y-4 sm:space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-4 sm:p-6">
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3">
                {faq.question}
              </h3>
              <p className="text-sm sm:text-base text-gray-700">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link 
            to="/faq" 
            className="inline-flex items-center gap-2 text-blue-500 hover:text-blue-600 font-medium transition-colors cursor-pointer"
          >
            <span>すべてのご質問を見る</span>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-lg"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
